import clsx from "clsx";

interface ProductDetailsModalProps {
  content: string;
  isOpen: boolean;
  onClose: () => void;
}

export function ProductDetailsModal({
  content,
  isOpen,
  onClose,
}: ProductDetailsModalProps): JSX.Element {
  const removeHtmlTags = (htmlString: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <div
      className={clsx("modal-overlay", { open: isOpen })}
      data-testid="product-modal"
    >
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>
          <i className="fa fa-times" />
        </button>
        <span className="modal-text">{removeHtmlTags(content)}</span>
      </div>
    </div>
  );
}
